import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  FullStressTypeInfoData,
  ActionType,
  IFullStressTypeInfoResponse,
} from "models/stressCheck/fullStressInformation";
import { httpStatus } from "configs/httpStatus";
import { getFullStressTypeInfoRequests } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./fullStressTypeInfoActions";

function* fullStressCheckTypeInfoSaga({
  payload,
}: {
  payload: FullStressTypeInfoData;
}) {
  try {
    const response: IFullStressTypeInfoResponse = yield call(
      getFullStressTypeInfoRequests,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetFullStressCheckTypeInfoWatcher() {
  yield takeLatest(
    ActionType.FULL_STRESS_INFO as any,
    fullStressCheckTypeInfoSaga
  );
}

export default [fork(onGetFullStressCheckTypeInfoWatcher)];
